import React from 'react';
export function CTASection() {
  return <section className="mb-16 bg-emerald-50 rounded-lg shadow-md p-8 text-center" data-id="element-22">
      <h2 className="text-2xl md:text-3xl font-bold text-emerald-800 mb-4" data-id="element-23">
        Ready to Take Control of Your Health?
      </h2>
      <p className="text-lg text-gray-700 mb-6 max-w-2xl mx-auto" data-id="element-24">
        If you've been struggling with diabetes like I was, you deserve to know
        about every option that could help. The formula I discovered combines
        all four key ingredients in one daily supplement.
      </p>
      <a href="https://track.marthaslife.blog/click" target="_blank" rel="noopener noreferrer" className="inline-block bg-emerald-600 hover:bg-emerald-700 text-white font-bold py-4 px-8 rounded-lg shadow-lg transition duration-300 text-lg cursor-pointer" onClick={() => {
      try {
        nbpix('event', 'lander_click');
      } catch (e) {
        console.warn('NB pixel not available', e);
      }
    }} data-id="element-25">
        See the Formula I Use
      </a>
      <p className="mt-4 text-sm text-gray-600" data-id="element-26">
        No obligation. Just information that could change your life like it
        changed mine.
      </p>
    </section>;
}